<template>
    <div class="download-page">
      <header class="page-header">
        <h1>下载中心</h1>
      </header>
      <div class="downloads">
        <div class="download-item" v-for="(item, index) in downloads" :key="index">
          <img :src="item.icon" alt="" class="icon" />
          <a :href="item.link" download class="download-link">{{ item.name }}</a>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DownloadPage',
    data() {
      return {
        downloads: [
          {
            name: 'SDK 下载 (鸿蒙)',
            link: 'https://dl.foxhank.top/pdftoolbox-1.0.0.har', // 替换为实际的下载链接
            icon: require('@/assets/harmonyos.png')
          },
          {
            name: '说明书下载 (PDF)',
            link: 'https://dl.foxhank.top/pdftoolbox.pdf', // 替换为实际的下载链接
            icon: require('@/assets/PDF.png') // PDF 图标
          }
        ]
      };
    }
  };
  </script>
  
  <style>
  body {
    font-family: Arial, sans-serif;
    background-color: #f4f4f4;
    color: #333;
  }
  
  .download-page {
    max-width: 800px;
    margin: 50px auto;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  
  .page-header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .downloads {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  
  .download-item {
    display: flex;
    align-items: center;
    margin: 10px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #fafafa;
    transition: transform 0.2s ease-in-out;
  }
  
  .download-item:hover {
    transform: translateY(-5px);
  }
  
  .icon {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }
  
  .download-link {
    color: #007bff;
    text-decoration: none;
    font-size: 1.1em;
  }
  
  .download-link:hover {
    text-decoration: underline;
  }
  </style>
  